import React from 'react';
import CustomButton from '../../../components/CustomButton/CustomButton';
import classes from './Hero.module.scss';
import { companyDetails } from '../../companyDetails';

export default (props) => (
  <div className={classes.hero}>
    <div className="container">
      <div className={classes.hero__box}>
        <h2 className={classes.box__header}>
          Sign up!
          <br />
        </h2>

        <p className={classes.box__additionalInfo}>
          If you have already signed up then please log in below, for details on signing up please contact us.
        </p>

        {props.isAuthenticated ? (
          <CustomButton label="DASHBOARD" onClick={() => props.history.push(props.dashboardLink)} secondary />
        ) : (
          <CustomButton
            label="SIGN UP"
            onClick={() => props.history.push(`/gym/${companyDetails.gymId}/signup`)}
            secondary
          />
        )}
      </div>
    </div>
  </div>
);
